import { IExceptionTelemetry } from '@microsoft/applicationinsights-web';

export class ExceptionTelemetry implements IExceptionTelemetry {
  error: Error;

  public constructor(error: Error) {
    this.error = error;
  }
}
